import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { entryStickerForParkingAcknowledgements } from "../../../constants/common";
import CheckboxInput from "../../../components/inputs/CheckboxInput";

interface AcknowledgementProps {
  isAcknowledgeStickerReceipt: boolean;
  setIsAcknowledgeStickerReceipt: Dispatch<SetStateAction<boolean>>
  isFieldsDisabled: boolean;
}

const Acknowledgement = ({ isAcknowledgeStickerReceipt, setIsAcknowledgeStickerReceipt, isFieldsDisabled }: AcknowledgementProps) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white flex flex-col gap-2 lg:gap-4 z-10 p-2 md:p-4 rounded-xl shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]">
      <ul className="list-disc list-inside">
        {entryStickerForParkingAcknowledgements.map((item) => (
          <li key={item} className="text-sm">
            {t(item)}
          </li>
        ))}
      </ul>

      <CheckboxInput
        id="acknowledgeStickerReceipt"
        label={t("acknowledgeStickerReceipt")}
        labelStyles="leading-[1.2]"
        checked={
          isAcknowledgeStickerReceipt ||
          isFieldsDisabled
        }
        setChecked={setIsAcknowledgeStickerReceipt}
        readOnly={isFieldsDisabled}
      />
    </div>
  );
};

export default Acknowledgement;
